<template>
  <div class="column is-9">
    <transition name="fade">
      <!--
      <div v-if="isLoading" class="loading">
        <pulse-loader :loading="isLoading"></pulse-loader>
      </div>
      v-else apres
      -->
      <div v-if="page && !isLoading" class="is-border is-radius-large has-bg-white content content-guide">
        <div class="column is-border-bottom is-paddingless-bottom">
          <h1>{{ page.data.title }}</h1>
          <!-- <a class="editBtn" :href="cmsPath+'/wp-admin/post.php?post='+page.data.ID+'&action=edit'" target="_blank">edit page</a> -->
        </div>

        <div class="column entry">
          <div class="entry-content" v-html="page.data.content"></div>
          <!--
          <div v-for="content in validContents" :id="content.id" :key="content.id">
            <div v-if="content.type === 'tip'" class="columns guide-focus-bloc is-info is-flex-mobile">
              <div class="column is-2-mobile is-2-tablet is-2-desktop is-1-widescreen is-1-fullhd has-text-centered">
                <i class="fal fa-hand-peace fa-2x"></i>
              </div>
              <div class="column" v-html="content.html">
              </div>
            </div>
            <div v-else v-html="page.content"></div>
          </div>
          -->
        </div>

        <div class="column is-border-top">
          <p>
            Cet article ne vous a pas aidé ?
            <a href="mailto:support@okgo.fr?subject=Message FAQ vadimm" target="_blank">
              Contactez-nous par mail
            </a>
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { api } from '../cmsApi'
  // import PulseLoader from '../components/PulseLoader'

  // const PrismicDOM = require('prismic-dom')

  export default {
    name: 'Page',
    // components: { PulseLoader },
    data () {
      return {
        isLoading: false,
        page: null,
        cmsPath: process.env.VUE_APP_CMS
        // contents: []
      }
    },
    computed: {
      pageId () {
        return this.$route.params.pageId
      },
      /*
      validContents () {
        return this.contents
      },
      */
    },
    watch: {
      $route: 'initComponent'
    },
    created () {
      this.initComponent()
    },
    methods: {
      async initComponent () {
        // let page = await api.fetchByID(this.pageId)
        /*
        let contentIds = page.data.contents.map(x => x.content.id)
        let rawContents = await api.fetchByIDs(contentIds)
        let contents = []
        for (let rawContent of rawContents) {
          let c = {
            id: rawContent.id,
            type: rawContent.type,
            destinations: rawContent.data.destinations,
            profils: rawContent.data.profils,
          }

          if (c.type === 'video') {
            c.html = rawContent.data.content.html
          } else {
            c.html = PrismicDOM.RichText.asHtml(rawContent.data.content)
          }
          contents.push(c)
        }
        this.contents = contents
        this.isLoading = false
        */
        this.isLoading = true
        if (api.isInit === false) {
          await api.init()
        }
        console.log('>>> fetchPage('+this.pageId+')')
        let page = await api.fetchPage(this.pageId)
        this.page = page
        this.isLoading = false
      }
    }
  }
</script>

<style lang="css" scoped>

  a.editBtn{ position:absolute;right:40px;top:30px; }

  div.guide-focus-bloc a {
    color: white !important;
    text-decoration: none !important;
  }

  .fade-enter-active, .fade-leave-active {
      transition: opacity .3s, transform .3s;
      transform: translateX(0px);
  }
  .fade-enter{
      opacity: 0;
      transform: translateX(-20px);
  }
  .fade-leave-to{
      opacity: 0;
      transform: translateX(40px);
  }

</style>
